import useMenuItems from './useMenuItems';
import { SearchField } from '../fields';

const SearchBar = () => {
  const menuItems = useMenuItems();
  return <SearchField options={menuItems} />;
};

export default SearchBar;
